import { SymbolCodepoints } from '@uag/react-core';
import { StepActionType } from '@uag/welcome-shared/src/api/models';

export const getActionIcon = (stepActionType: StepActionType): SymbolCodepoints | undefined => {
    const actionIcons: {
        [key in StepActionType]: SymbolCodepoints | undefined;
    } = {
        [StepActionType.FileUpload]: 'upload',
        [StepActionType.FileDownload]: 'download',
        [StepActionType.EditCompanyData]: 'edit',
        [StepActionType.InsertCompanyData]: 'add',
        [StepActionType.ViewCompanyData]: 'visibility',
        [StepActionType.SignContractLink]: 'draw',
        [StepActionType.ActivateMyDoka]: 'check',
        [StepActionType.DownloadContract]: 'download',
        [StepActionType.MyDokaLink]: undefined,
        [StepActionType.OnlineShopLink]: undefined,
    };

    if (!actionIcons[stepActionType]) {
        return undefined;
    }

    return actionIcons[stepActionType];
};
